import * as React from "react";
import ButtonBordered from "src/components/shared/Button/ButtonBordered";
import {
  ConfirmationLabel,
  ConfirmationPopupWrapper,
  ConfirmationRowWrapper,
  CloseConfirmationPopupButton,
} from "./ConfirmationPopup.components";
import { ReactComponent as CloseIcon } from "src/images/closeIcon.svg";

export interface Props extends React.ComponentPropsWithRef<"div"> {
  onConfirm: () => void;
  onCancel: () => void;
  popupLabel?: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
}

const ConfirmationPopup: React.FunctionComponent<Props> = ({
  onCancel,
  onConfirm,
  cancelButtonLabel,
  confirmButtonLabel,
  popupLabel,
  ...props
}) => (
  <ConfirmationPopupWrapper data-cy="taskItemConfirmationPopup" {...props}>
    <CloseConfirmationPopupButton onClick={onCancel}>
      <CloseIcon />
    </CloseConfirmationPopupButton>
    <ConfirmationLabel>{popupLabel ?? "Are you sure?"}</ConfirmationLabel>
    <ConfirmationRowWrapper>
      <ButtonBordered themeColor="background" onClick={onCancel}>
        {cancelButtonLabel ?? "Cancel"}
      </ButtonBordered>
      <ButtonBordered onClick={onConfirm} themeColor="buttonPrimary">
        {confirmButtonLabel ?? "Yes"}
      </ButtonBordered>
    </ConfirmationRowWrapper>
  </ConfirmationPopupWrapper>
);

export default ConfirmationPopup;
